<div class="sidebar-header" [class.collapsed]="isCollapsed">
  <div class="logo-wrapper">
    <img
      class="logo-icon"
      src="assets/images/beExpert.svg"
      alt="BeExpert Logo"
    />
    <div class="logo-text-group" *ngIf="!isCollapsed">
      <span class="logo-title">BeExpert.ai</span>
      <span class="logo-subtitle">HIRING SUITE</span>
    </div>
  </div>
  <button class="collapse-toggle-btn" (click)="onToggleCollapse()">
    <!-- Left arrow when expanded -->
    <svg
      *ngIf="!isCollapsed"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="15 18 9 12 15 6" />
    </svg>
    <!-- Hamburger menu icon when collapsed -->
    <svg
      *ngIf="isCollapsed"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  </button>
</div>

<div class="workspace-label" *ngIf="!isCollapsed">WORKSPACE</div>

<!-- Navigation List -->
<nav class="sidebar-nav">
  <a
    class="nav-item"
    [class.active]="activeTab === 'dashboard'"
    (click)="selectTab('dashboard')"
    title="Dashboard"
  >
    <svg
      class="nav-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
    <span class="nav-label" *ngIf="!isCollapsed">Dashboard</span>
  </a>

  <a
    class="nav-item"
    [class.active]="activeTab === 'jobs'"
    (click)="selectTab('jobs')"
    title="Jobs"
  >
    <svg
      class="nav-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
    <span class="nav-label" *ngIf="!isCollapsed">Jobs</span>
  </a>

  <a
    class="nav-item"
    [class.active]="activeTab === 'candidates'"
    (click)="selectTab('candidates')"
    title="Candidates"
  >
    <svg
      class="nav-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
    <span class="nav-label" *ngIf="!isCollapsed">Candidates</span>
  </a>

  <!--<a class="nav-item" [class.active]="activeTab === 'assessments'" (click)="selectTab('assessments')"
    title="Assessments">
    <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
    <span class="nav-label" *ngIf="!isCollapsed">Assessments</span>
  </a>-->

  <!-- <a class="nav-item" [class.active]="activeTab === 'interview'" (click)="selectTab('interview')" title="Interview">
    <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M23 7a2 2 0 0 0-2.45-1.45L16 7V5a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2l4.55 1.45A2 2 0 0 0 23 17V7z" />
    </svg>
    <span class="nav-label" *ngIf="!isCollapsed">Interview</span>
  </a> -->

  <!-- <a class="nav-item" [class.active]="activeTab === 'one_one_interview'" (click)="selectTab('one_one_interview')" title="1:1 Interview">
    <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
    <span class="nav-label" *ngIf="!isCollapsed">1:1 Interview</span>
  </a> -->
</nav>

<div class="sidebar-footer">
  <a class="nav-item logout-nav-item" (click)="onLogout()" title="Logout">
    <svg
      class="nav-icon logout-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
    <span class="nav-label" *ngIf="!isCollapsed">Logout</span>
  </a>
</div>
